import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { HiOutlineSearch } from 'react-icons/hi'
import { useSelector } from 'react-redux'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import InputText from '../Inputs/InputText'
import SelectOfCategories from '../Inputs/SelectOfCategories'
import Switch from '../Inputs/Switch'
import { RootState } from '../../redux/store'

const server = process.env.REACT_APP_SERVER_URL

const AdvancedInventoryForm: React.FC<IAdvancedInventoryForm> = ({
  onSubmit,
  onCloseAdvancedForm,
}) => {
  const form = useForm()

  const [categoriesValues, setCategoriesValues] = useState<any[]>([])

  const [subCategories, setSubCategories] = useState<any>([])

  const categories = useSelector((state: RootState) => state.ctgr.categories)

  useEffect(() => {
    setCategoriesValues([
      { text: 'Todos', value: 'all' },
      ...categories.map((v) => ({ text: v.name, value: v.id })),
    ])
    // setCategoriesValues(
    //   categories
    //     .filter((category) => category.children.length !== 0)
    //     .map((category) => ({ value: category.id, text: category.name }))
    // )
  }, [categories])

  return (
    <Form form={form} onSubmit={onSubmit} classes="gap-x-2 p-2">
      <HiOutlineSearch
        fontSize={25}
        className="text-primaryGray-400 col-span-1"
      />
      <label className="col-span-11 text-left dark:text-white text-darkere">
        Búsqueda avanzada
      </label>

      <FormItem name="name" classes="lg:col-span-8 col-span-12 row-start-2">
        <InputText small label="Nombre" maxLength={80} />
      </FormItem>

      <FormItem
        name="description"
        classes="lg:col-span-4 col-span-12 row-start-3"
      >
        <InputText small label="Descripción" maxLength={80} />
      </FormItem>

      <FormItem name="code" classes="lg:col-span-4 col-span-12 row-start-3">
        <InputText small label="Código" maxLength={80} />
      </FormItem>

      <FormItem
        defaultValue={categoriesValues[0]}
        name="category"
        classes="lg:col-span-4 col-span-12 row-start-2"
      >
        {/* <InputText small label="Categoría" maxLength={80} /> */}
        <SelectOfCategories
          options={categoriesValues}
          setSelectedHelper={async ({ value }) => {
            console.log('values', value)
            if (value !== 'all') {
              let response = await axios.get(
                `${server}/inventory/subcategory?idCategory=${value}`
              )
              setSubCategories([
                { text: 'Todos', value: 'all' },
                ...response.data.subcategories.map((v) => ({
                  value: v.id,
                  text: v.name,
                })),
              ])
            } else {
              setSubCategories([{ text: 'Todos', value: 'all' }])
            }
            // console.log('values..', values)
            // setSubCategories([
            //   { text: 'Todos', value: '0' },
            //   ...(categories
            //     .find((category) => category?.id === values.value)
            //     ?.children.map((sub) => ({
            //       text: sub.name,
            //       value: sub.id,
            //     })) as any[]),
            // ])
          }}
          label="Categoría"
        />
      </FormItem>

      {/* <FormItem
        defaultValue={subCategories[0]}
        name="subcategory"
        classes="lg:col-span-4 col-span-12 row-start-3"
      >
        <SelectOfCategories
          options={subCategories}
          setSelectedHelper={(values) => console.log('values', values)}
          label="Sub Categoría"
        />
      </FormItem> */}

      {/* <FormItem
        name="exempt"
        classes="lg:col-span-4 col-span-12 row-start-4 mt-3"
      >
        <Switch forForm={true} small label="Exento de Impuesto" />
      </FormItem> */}

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCloseAdvancedForm()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>
    </Form>
  )
}

interface IAdvancedInventoryForm {
  onSubmit: Function
  onCloseAdvancedForm: Function
}

export default AdvancedInventoryForm
